import React from "react";
import PropTypes from "prop-types";
import { SelectDownArrow } from "../../icons";

interface Item {
    id: string;
    value: string;
}

interface SelectBoxProps {
    items: any;
    defaultSelectedItemIndex?: number;
    selectedValue?: string;
    onChange: (item: Item) => void;
}

interface SelectBoxState {
    items: Item[];
    showItems: boolean;
    selectedItem: Item | null;
}

class SelectBox extends React.Component<SelectBoxProps, SelectBoxState> {
    static propTypes = {
        items: PropTypes.array.isRequired,
        defaultSelectedItemIndex: PropTypes.number,
        selectedValue: PropTypes.string, // Updated prop type
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        defaultSelectedItemIndex: 0,
        selectedValue: null,
    };

    constructor(props: SelectBoxProps) {
        super(props);

        this.state = {
            items: props.items || [],
            showItems: false,
            selectedItem: this.getSelectedItem(props),
        };
    }

    componentDidUpdate(prevProps: SelectBoxProps) {
        if (prevProps.selectedValue !== this.props.selectedValue) {
            const selectedItem = this.state.items.find(
                (item) => item.value === this.props.selectedValue
            );
            if (selectedItem) {
                this.setState({ selectedItem });
            }
        }
    }

    getSelectedItem = (props: SelectBoxProps): Item | null => {
        const { items, defaultSelectedItemIndex, selectedValue } = props;
        if (selectedValue) {
            return (
                items.find((item) => item.value === selectedValue) ||
                items[defaultSelectedItemIndex]
            );
        }
        return items[defaultSelectedItemIndex] || null;
    };

    dropDown = () => {
        this.setState((prevState) => ({
            showItems: !prevState.showItems,
        }));
    };

    selectItem = (item: Item) => {
        this.setState(
            {
                selectedItem: item,
                showItems: false,
            },
            () => {
                this.props.onChange(this.state.selectedItem!);
            }
        );
    };

    render() {
        return (
            <div className="select-box--box">
                <div className="select-box--container">
                    <div className="select-box--selected-item" onClick={this.dropDown}>
                        {this.state.selectedItem?.value}
                    </div>
                    <div className="select-box--arrow">
            <span
                onClick={this.dropDown}
                className={`${
                    this.state.showItems
                        ? "select-box--arrow-up"
                        : "select-box--arrow-down"
                }`}
            >
              <SelectDownArrow />
            </span>
                    </div>

                    <div
                        style={{ display: this.state.showItems ? "block" : "none" }}
                        className={"select-box--items"}
                    >
                        {this.state.items.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => this.selectItem(item)}
                                className={this.state.selectedItem === item ? "selected" : ""}
                            >
                                {item.value}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectBox;
